// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

@media (min-width: 768px) {
    div.table-measures tbody{
        display: block;
        height: 51vh;
        overflow: auto;
        margin-top: 8px;
    }

    div.table-measures thead, div.table-measures tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;/* even columns width , fix width of table too*/
        overflow: auto;
    }
    /*div.table-measures thead {*/
    /*    width: calc( 100% - 1em )!* scrollbar is average 1em/16px width, remove it from thead width *!*/
    /*}*/

    /* Scrollbar styles */
    div.table-measures tbody::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 0.23);
        border-radius: 5px;
    }
    /* Handle */
    div.table-measures tbody::-webkit-scrollbar-thumb {
        background: var(--blue);
        border-radius: 5px;
        border: 1px solid white;
    }
    div.table-measures .p-datatable-wrapper{
        overflow: hidden !important;
    }

    div.table-measures table.p-datatable-table thead.p-datatable-thead {
        background-color: transparent !important;
    }
}

div.table-measures .p-datatable-wrapper{
    max-height: 58vh;
}

.table-measures div.p-paginator,
.table-measures table.p-datatable-table tbody.p-datatable-tbody tr,
.table-measures table.p-datatable-table thead.p-datatable-thead th{
    background: transparent;
    color: white;
    font-size: 14px;
}

.table-measures table.p-datatable-table tbody.p-datatable-tbody tr:hover{
    color: var(--blue);
}

.table-measures table.p-datatable-table thead.p-datatable-thead {
    background-color: var(--blue-dark) !important;
}
.table-measures table.p-datatable-table thead.p-datatable-thead tr:after{
    content: '';
    border-bottom: 2px solid white;
    width: 100%;
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
}
.table-measures table.p-datatable-table thead.p-datatable-thead th{
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 300;
    border: none;
    padding-bottom: 20px;
    /*border-bottom: 2px solid #ffffff;*/
}
.table-measures table.p-datatable-table tbody.p-datatable-tbody{

}

.table-measures table.p-datatable-table tbody.p-datatable-tbody td{
    border: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
    padding: 25px 16px;
    max-height: 21.5px;
}

.p-dialog .p-dialog-header .p-dialog-header-close:hover,
.p-dialog .p-dialog-footer .p-button:hover,
.table-measures .p-datatable-tbody a.reference-column:hover {
    color: var(--blue);
}

div.p-paginator.p-component{
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.24);
    border-radius: 8px;
    width: fit-content;
    padding: 0;
}
div.p-paginator.p-component .p-paginator-pages{
    margin: 0 10px;
}
div.p-paginator.p-component .p-paginator-pages button.p-paginator-page{
    min-width: 2rem;
    height: 2rem;
    font-size: 12px;
    line-height:0
}
div.p-paginator .p-paginator-pages button.p-paginator-page.p-highlight,
div.p-paginator.p-component .p-paginator-pages button.p-paginator-page:hover{
    background: rgba(75, 196, 236, 0.16);
    border-radius: 50%;
    color: var(--blue);
    border:none;
}
div.p-paginator.p-component .p-paginator-pages button.p-paginator-page:focus{
    outline: none;
    box-shadow: none;
}

div.p-paginator.p-component .p-paginator-first:hover,
div.p-paginator.p-component .p-paginator-prev:hover,
div.p-paginator.p-component .p-paginator-next:hover,
div.p-paginator.p-component .p-paginator-last:hover{
    background: transparent !important;
    outline: none;
    box-shadow: none;
    border:none !important;
    color: var(--blue) !important;
}

div.p-paginator.p-component .p-paginator-prev:focus,
div.p-paginator.p-component .p-paginator-first:focus,
div.p-paginator.p-component .p-paginator-next:focus,
div.p-paginator.p-component .p-paginator-last:focus{
    outline: none;
    box-shadow: none;
}
div.p-paginator.p-component .p-paginator-prev{

}

div.p-paginator.p-component .p-paginator-prev:after{
    content: '';
    position: absolute;
    right: 0;
    top: 15%;
    height: 70%;
    border-left: 1px solid rgba(255, 255, 255, 0.24);
}
div.p-paginator.p-component .p-paginator-next:after{
    content: '';
    position: absolute;
    left: 0;
    top: 15%;
    height: 70%;
    border-left: 1px solid rgba(255, 255, 255, 0.24);
}


@media (max-width: 768px) {
    div.table-measures .p-datatable-wrapper{
        max-height: 58vh;
    }
    .table-measures table.p-datatable-table thead.p-datatable-thead th{
        font-size: 12px;
    }
    .table-measures table.p-datatable-table tbody.p-datatable-tbody td{
        font-size: 10px;
        padding: 15px 8px;
    }
}

@media (max-width: 640px) {
    div.table-measures .p-datatable-wrapper{
        max-height: 50vh;
    }
    .table-measures table.p-datatable-table tbody.p-datatable-tbody td{
        padding: 15px 8px;
    }
}

@media (max-width: 550px) {
    div.table-measures .p-datatable-wrapper{
        max-height: 45vh;
    }
}

@media (max-width: 450px) {
    div.table-measures .p-datatable-wrapper{
        max-height: 50vh;
    }
}
@media (max-width: 375px) {
    div.table-measures .p-datatable-wrapper{
        max-height: 45vh;
    }
    .table-measures table.p-datatable-table thead.p-datatable-thead th{
        padding: 8px 16px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/table.css"],"names":[],"mappings":";;AAEA;IACI;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB,CAAC,+CAA+C;QACnE,cAAc;IAClB;IACA,6BAA6B;IAC7B,qGAAqG;IACrG,IAAI;;IAEJ,qBAAqB;IACrB;QACI,WAAW;QACX,YAAY;QACZ,qCAAqC;QACrC,kBAAkB;IACtB;IACA,WAAW;IACX;QACI,uBAAuB;QACvB,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,oCAAoC;AACxC;AACA;;AAEA;;AAEA;IACI,YAAY;IACZ,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf;AACJ;AACA;;IAEI,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;;;;IAII,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;;;IAII,aAAa;IACb,gBAAgB;AACpB;AACA;;AAEA;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,gDAAgD;AACpD;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,gDAAgD;AACpD;;;AAGA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["\n\n@media (min-width: 768px) {\n    div.table-measures tbody{\n        display: block;\n        height: 51vh;\n        overflow: auto;\n        margin-top: 8px;\n    }\n\n    div.table-measures thead, div.table-measures tbody tr {\n        display: table;\n        width: 100%;\n        table-layout: fixed;/* even columns width , fix width of table too*/\n        overflow: auto;\n    }\n    /*div.table-measures thead {*/\n    /*    width: calc( 100% - 1em )!* scrollbar is average 1em/16px width, remove it from thead width *!*/\n    /*}*/\n\n    /* Scrollbar styles */\n    div.table-measures tbody::-webkit-scrollbar {\n        width: 10px;\n        height: 10px;\n        background: rgba(255, 255, 255, 0.23);\n        border-radius: 5px;\n    }\n    /* Handle */\n    div.table-measures tbody::-webkit-scrollbar-thumb {\n        background: var(--blue);\n        border-radius: 5px;\n        border: 1px solid white;\n    }\n    div.table-measures .p-datatable-wrapper{\n        overflow: hidden !important;\n    }\n\n    div.table-measures table.p-datatable-table thead.p-datatable-thead {\n        background-color: transparent !important;\n    }\n}\n\ndiv.table-measures .p-datatable-wrapper{\n    max-height: 58vh;\n}\n\n.table-measures div.p-paginator,\n.table-measures table.p-datatable-table tbody.p-datatable-tbody tr,\n.table-measures table.p-datatable-table thead.p-datatable-thead th{\n    background: transparent;\n    color: white;\n    font-size: 14px;\n}\n\n.table-measures table.p-datatable-table tbody.p-datatable-tbody tr:hover{\n    color: var(--blue);\n}\n\n.table-measures table.p-datatable-table thead.p-datatable-thead {\n    background-color: var(--blue-dark) !important;\n}\n.table-measures table.p-datatable-table thead.p-datatable-thead tr:after{\n    content: '';\n    border-bottom: 2px solid white;\n    width: 100%;\n    display: block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n.table-measures table.p-datatable-table thead.p-datatable-thead th{\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 300;\n    border: none;\n    padding-bottom: 20px;\n    /*border-bottom: 2px solid #ffffff;*/\n}\n.table-measures table.p-datatable-table tbody.p-datatable-tbody{\n\n}\n\n.table-measures table.p-datatable-table tbody.p-datatable-tbody td{\n    border: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.24);\n    padding: 25px 16px;\n    max-height: 21.5px;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-close:hover,\n.p-dialog .p-dialog-footer .p-button:hover,\n.table-measures .p-datatable-tbody a.reference-column:hover {\n    color: var(--blue);\n}\n\ndiv.p-paginator.p-component{\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.24);\n    border-radius: 8px;\n    width: fit-content;\n    padding: 0;\n}\ndiv.p-paginator.p-component .p-paginator-pages{\n    margin: 0 10px;\n}\ndiv.p-paginator.p-component .p-paginator-pages button.p-paginator-page{\n    min-width: 2rem;\n    height: 2rem;\n    font-size: 12px;\n    line-height:0\n}\ndiv.p-paginator .p-paginator-pages button.p-paginator-page.p-highlight,\ndiv.p-paginator.p-component .p-paginator-pages button.p-paginator-page:hover{\n    background: rgba(75, 196, 236, 0.16);\n    border-radius: 50%;\n    color: var(--blue);\n    border:none;\n}\ndiv.p-paginator.p-component .p-paginator-pages button.p-paginator-page:focus{\n    outline: none;\n    box-shadow: none;\n}\n\ndiv.p-paginator.p-component .p-paginator-first:hover,\ndiv.p-paginator.p-component .p-paginator-prev:hover,\ndiv.p-paginator.p-component .p-paginator-next:hover,\ndiv.p-paginator.p-component .p-paginator-last:hover{\n    background: transparent !important;\n    outline: none;\n    box-shadow: none;\n    border:none !important;\n    color: var(--blue) !important;\n}\n\ndiv.p-paginator.p-component .p-paginator-prev:focus,\ndiv.p-paginator.p-component .p-paginator-first:focus,\ndiv.p-paginator.p-component .p-paginator-next:focus,\ndiv.p-paginator.p-component .p-paginator-last:focus{\n    outline: none;\n    box-shadow: none;\n}\ndiv.p-paginator.p-component .p-paginator-prev{\n\n}\n\ndiv.p-paginator.p-component .p-paginator-prev:after{\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 15%;\n    height: 70%;\n    border-left: 1px solid rgba(255, 255, 255, 0.24);\n}\ndiv.p-paginator.p-component .p-paginator-next:after{\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 15%;\n    height: 70%;\n    border-left: 1px solid rgba(255, 255, 255, 0.24);\n}\n\n\n@media (max-width: 768px) {\n    div.table-measures .p-datatable-wrapper{\n        max-height: 58vh;\n    }\n    .table-measures table.p-datatable-table thead.p-datatable-thead th{\n        font-size: 12px;\n    }\n    .table-measures table.p-datatable-table tbody.p-datatable-tbody td{\n        font-size: 10px;\n        padding: 15px 8px;\n    }\n}\n\n@media (max-width: 640px) {\n    div.table-measures .p-datatable-wrapper{\n        max-height: 50vh;\n    }\n    .table-measures table.p-datatable-table tbody.p-datatable-tbody td{\n        padding: 15px 8px;\n    }\n}\n\n@media (max-width: 550px) {\n    div.table-measures .p-datatable-wrapper{\n        max-height: 45vh;\n    }\n}\n\n@media (max-width: 450px) {\n    div.table-measures .p-datatable-wrapper{\n        max-height: 50vh;\n    }\n}\n@media (max-width: 375px) {\n    div.table-measures .p-datatable-wrapper{\n        max-height: 45vh;\n    }\n    .table-measures table.p-datatable-table thead.p-datatable-thead th{\n        padding: 8px 16px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
